import { useAppConfig } from '@common/app-config';
import { useUBL } from '@common/log-manager';
import { withImageOptimizationQuery } from '@common/utils';
import { redirectToLandingUrl, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useDescriptionTopBannerService = () => {
  const { isZigzagApp } = useAppConfig();
  const sendUBL = useUBL();

  const param = useCatalogProductIdParams();
  const {
    product: { description_top_banner },
  } = usePdpBaseInfo(param);

  const handleBannerClick = () => {
    if (!description_top_banner?.landing_url) {
      return;
    }
    if (description_top_banner.ubl?.object) {
      const { section, type, id } = description_top_banner.ubl?.object ?? {};

      sendUBL({
        navigation: 'product_detail',
        category: 'click',
        object_section: section ?? '',
        object_type: type ?? '',
        object_id: id ?? '',
      });
    }

    return redirectToLandingUrl({ isZigzagApp, landing_url: description_top_banner.landing_url });
  };

  const sendTopBannerImpressionUBL = () => {
    if (description_top_banner && description_top_banner.ubl?.object) {
      const { section, type, id } = description_top_banner.ubl?.object ?? {};

      sendUBL({
        navigation: 'product_detail',
        category: 'impression',
        object_section: section ?? '',
        object_type: type ?? '',
        object_id: id ?? '',
      });
    }
  };

  return {
    isHide: !description_top_banner,
    imageUrl:
      withImageOptimizationQuery(description_top_banner?.image_url, { format: 'webp', quality: 80 }) ??
      description_top_banner?.image_url ??
      '',
    handleBannerClick,
    sendTopBannerImpressionUBL,
  };
};
